import styled from 'styled-components'

const MenuButtonContainer = styled.div`
  padding: 0;
  box-sizing: border-box;
  display: ${props => (props.show ? 'block' : 'none')} !important;
`

const MenuItem = styled.div`
  padding: 25px 25px 25px 25px;
  display: grid;
  grid-template-columns: 50px auto;
  grid-template-rows: auto;
  align-items: center;
  border-bottom: 1px solid #3c4259;
  color: #a4a9b7;
  cursor: pointer;
  &:hover {
    background-color: #3395fe;
    color: #99cafe;
  }
`
const MenuItemText = styled.div`
  font-weight: normal;
  font-size: 15px;
  user-select: none;
`

const MenuLogo = styled.div`
  position: absolute;
  bottom: 20px;
  left: 10px;
  display: grid;
  grid-template-columns: 100px;
  grid-template-rows: auto auto auto;
  justify-items: center;
  font-weight: 600;
  font-size: 12px;
  color: #a4a9b7;
`

export {MenuButtonContainer, MenuItem, MenuItemText, MenuLogo}
